export type Currency = 'MVR' | 'USD';

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  MVR: 'MVR',
  USD: '$',
};

export function formatCurrency(amount: number | string | { toNumber?: () => number; toString?: () => string } | any, currency: Currency = 'MVR'): string {
  const symbol = CURRENCY_SYMBOLS[currency];
  
  // Handle Prisma Decimal types and other numeric formats
  let numAmount: number;
  if (typeof amount === 'number') {
    numAmount = amount;
  } else if (typeof amount === 'string') {
    numAmount = parseFloat(amount);
  } else if (amount && typeof amount.toNumber === 'function') {
    // Prisma Decimal type
    numAmount = amount.toNumber();
  } else if (amount && typeof amount.toString === 'function') {
    numAmount = parseFloat(amount.toString());
  } else {
    numAmount = Number(amount) || 0;
  }
  
  return `${symbol} ${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function getCurrencySymbol(currency: Currency = 'MVR'): string {
  return CURRENCY_SYMBOLS[currency];
}

